import { ExtendedProjectStatus } from '../../../../../typings/api/skymap/rest/v0/.common';
import { ProjectModel } from '../../../../../typings/api/skymap/rest/v1/.common';

/**
 * Derives the ExtendedProjectStatus from a v1 ProjectModel by inspecting
 * project.status, latestArchiveJob, and latestRestoreJob.
 */
export function resolveExtendedStatus(project: ProjectModel): ExtendedProjectStatus {
  const archiveJob = project.latestArchiveJob;
  const restoreJob = project.latestRestoreJob;

  if (restoreJob) {
    switch (restoreJob.status) {
      case 'IDLE':
        return 'RESTORE_IDLE';
      case 'IN_PROGRESS':
        return 'RESTORE_IN_PROGRESS';
      case 'ERROR':
        return 'RESTORE_ERROR';
      case 'DONE':
        return 'RESTORE_DONE';
    }
  }

  if (archiveJob) {
    switch (archiveJob.status) {
      case 'IDLE':
        return 'ARCHIVE_IDLE';
      case 'IN_PROGRESS':
        return 'ARCHIVE_IN_PROGRESS';
      case 'ERROR':
        return 'ARCHIVE_ERROR';
      case 'DONE':
        return 'ARCHIVED';
    }
  }

  return project.status === 'DISABLED' ? 'DISABLED' : 'ACTIVE';
}
